<template>
  <v-layout column fill-height justify-space-between>
    <protocols-table :headers="headers" :title="title" :filters="filters" />
    <v-btn style="width: fit-content; align-self: flex-end" color="primary" class="mr-5 mb-5" depressed @click="() => openProtocolPage()">
      {{ $t('protindex.add') }}
      <v-icon right> mdi-plus </v-icon>
    </v-btn>
  </v-layout>
</template>

<script>
import protocolsTable from '@/components/protocols/Table';
import i18n from '@/translations/i18n';
import { configAPI } from '@/services';

export default {
  components: { protocolsTable },
  data: () => ({
    title: i18n.t('protindex.title'),
    headers: [
      { text: i18n.t('protindex.nlname'), value: 'name', selected: true },
      { text: i18n.t('protindex.enname'), value: 'en', selected: false },
      { text: i18n.t('protindex.frname'), value: 'fr', selected: false },
      { text: i18n.t('protindex.account'), value: 'account', selected: true },
      { text: i18n.t('protindex.price'), value: 'price', selected: true },
      { text: i18n.t('protindex.fixed'), value: 'fixedPrice', selected: true },
      { text: i18n.t('protindex.tax'), value: 'tax', align: 'left', selected: true },
      { text: i18n.t('protindex.edit'), value: 'action', align: 'end', sortable: false, selected: true },
    ],
    taxes: [],
    prices: [
      { name: 'vast', value: true },
      { name: 'variabel', value: false },
    ],
  }),
  computed: {
    filters() {
      return {
        tax: {
          vTag: 'select',
          label: i18n.t('protindex.filter'),
          items: this.taxes,
          options: { multiple: true },
        },
      };
    },
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    openProtocolPage(id) {
      this.$router.push({ path: `/settings/protocol/${id}` });
    },
    async getConfig() {
      try {
        const {
          data: { tax },
        } = await configAPI.getProductConfig();
        this.taxes = tax;
      } catch (err) {
        await this.setError(err.message);
      }
    },
  },
};
</script>
